import type { ApiRoutes, AuthPipelineRoutes } from '@tempo-io/id-app/rpc';
import { hc } from 'hono/client';
import type { KyInstance } from 'ky';

export const getIdServiceApi = ({
  prefixUrl = '',
  client, // should include bearer token hook
}: {
  prefixUrl?: string;
  client: KyInstance;
}) =>
  hc<ApiRoutes>('/api/', {
    fetch: (input: RequestInfo | URL, requestInit?: RequestInit) => {
      return client(`${prefixUrl}${input}`, {
        method: requestInit?.method,
        headers: {
          'content-type': 'application/json',
          ...requestInit?.headers,
        },
        body: requestInit?.body,
      });
    },
  });

export const getAuthPipelineApi = ({ prefixUrl = '' }: { prefixUrl?: string } = {}) =>
  hc<AuthPipelineRoutes>(`${prefixUrl}/auth-pipeline/`);
